import React from "react";
import MobileNav from "../../components/mobile/nav/MobileNav";
import Footer from "../../components/mobile/footer/Footer";
import LoginComponent from "../../components/mobile/login/Login";

export default function Login() {
  return (
    <>
      <MobileNav />
      <LoginComponent />
      <Footer />
    </>
  );
}
